<template>
  <b-modal
    @close="cancelAction"
    :id="`modal-retain-${file.idAprobacion}`"
    :ref="`modal-retain-${file.idAprobacion}`"
    :title="`Retener documento Nº ${file.numero}`"
    ok-title="Confirmar"
    @ok="handleOk"
    size="lg"
    ok-only
    no-close-on-backdrop
    data-cy="add-step"
  >
    <h4 class="text-primary">
      Este documento no quedará disponible para suplencia
    </h4>
    <form data-vv-scope="retain-form">
      <div class="row">
        <div class="col-12">
          <vs-textarea
            class="mb-2"
            maxlength="1000"
            counter="1000"
            label="Comentario"
            v-model="comment"
            name="comment"
            v-validate="{required: true, min: 5}"
          />
          <div v-if="errors.first('retain-form.comment')"
               class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
               style="height: 20px;">
            <span class="span-text-validation">
              {{errors.first('retain-form.comment')}}
            </span>
          </div>
        </div>
      </div>
    </form>
  </b-modal>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';

import { retainFile } from '@/febos/servicios/api/aprobaciones.api';

export default {
  data() {
    return {
      comment: ''
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'FileOnFlow'
    ])
  },
  watch: {
    file() {
      this.comment = '';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'updateRetainFile'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async sendAction() {
      const isValid = await this.validateForm('retain-form');
      if (!isValid) {
        return;
      }

      await retainFile({
        aprobacionId: this.file.idAprobacion,
        comment: this.comment,
        pasoId: this.file.pasoActualId,
        ejecucionId: this.flowId
      });
      this.updateRetainFile({ id: this.file.idAprobacion });
      await this.$bvToast.toast(
        'El documento va a quedar retenido para tu gestión',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.newStep = {};
      this.$refs[`modal-retain-${ this.file.idAprobacion}`].hide();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.sendAction();
    },
    cancelAction() {
      this.newStep = {};
      this.$refs[`modal-retain-${ this.file.idAprobacion}`].hide();
    }
  },
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {}
    },
    flowId: {
      type: String
    }
  }
};
</script>
<style>
.type-resend {
  justify-content: space-evenly;
}
</style>
